import { dldl, yyyy } from "../../store.svelte";
import { toast } from "../../lib/toast.svelte.ts";
const url: string = yyyy.uri.api;

export default async () => {
	let _hdrs = {
		"Content-Type": "application/json",
		Authorization: "Bearer " + yyyy.sesh.logtoken.token,
		Accept: "application/json",
	};
	let _body = JSON.stringify({ lw_id: yyyy.sesh.activeLivewire.wireident });
	let fetchopts = { method: "post", headers: _hdrs, body: _body };

	const resp = await fetch(`${url}/rpc/getlayernames`, fetchopts);
	if (resp.ok) {
		let data = await resp.json();
		data.layernames.forEach((element: any) => {
			element.vis = true;
		});
		let ret = data.layernames
		return ret
	}
	if (!resp.ok) {
		dldl('getTableNames.svelte', 'Fetching table names failed.')
		toast.error('Fetching table names failed.')
		console.log("fetching layers failed");
	}
};
